// eslint-disable-next-line no-unused-vars
/* global __webpack_public_path__:writable */

import { Setup } from "ruffle-core";

let currentScriptURL = null;

try {
    if (
        document.currentScript instanceof HTMLScriptElement &&
        document.currentScript.src !== ""
    ) {
        let src = document.currentScript.src;

        // CDNs allow omitting the filename. If it's omitted, append a slash to
        // prevent the last component from being dropped.
        if (!src.endsWith(".js") && !src.endsWith("/")) {
            src += "/";
        }

        currentScriptURL = new URL(".", src);
    }
} catch (e) {
    console.warn("Unable to get currentScript URL", e);
}

function publicPath(config) {
    // Default to the directory where this script resides.
    let path = currentScriptURL?.href ?? "";
    if (
        "publicPath" in config &&
        config.publicPath !== null &&
        config.publicPath !== undefined
    ) {
        path = config.publicPath;
    }

    // Webpack expects the paths to end with a slash.
    if (path !== "" && !path.endsWith("/")) {
        path += "/";
    }

    return path;
}

// dirplayer-rs fork: namespace under window.dirplayer_RufflePlayer to avoid
// colliding with stock Ruffle if both bundles end up on the same page (e.g.
// via a browser extension or another script tag).
Setup.installRuffle("local", {
    onFirstLoad: () => {
        __webpack_public_path__ = publicPath(window.dirplayer_RufflePlayer?.config);
    },
});
